module.exports = __webpack_public_path__ + "static/r21-c61844e7efdc0967c83b2258e78eed38.jpg";